import { AbstractClient, CompositionClient } from "@/app/client";

export interface ErrorFeedbackCreate {
  message: string;
  page_url?: string | null;
  page_kind?: "404" | "error" | null;
  error_message?: string | null;
  user_agent?: string | null;
}

export interface ErrorFeedbackResponse {
  sent: boolean;
}

export default class APIErrorFeedback extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  submit = async (
    data: ErrorFeedbackCreate,
  ): Promise<ErrorFeedbackResponse> => {
    const res = await this._fetch({
      url: `/error-feedback/`,
      method: "POST",
      body: data,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
